import { clsx } from 'clsx';
import { Cloud, Folder, Link2, Star, Trash2 } from 'lucide-react';

const navItems = [
  { icon: Folder, label: '全部文件', value: 'all' },
  { icon: Star, label: '收藏', value: 'starred' },
  { icon: Link2, label: '分享链接', value: 'shared' },
  { icon: Trash2, label: '回收站', value: 'trash' },
];

interface SidebarProps {
  active?: string;
  onChange?: (value: string) => void;
  usage: number;
}

export function Sidebar({ active = 'all', onChange, usage }: SidebarProps) {
  return (
    <aside className="glass-panel flex w-full flex-col gap-8 rounded-3xl p-6 text-white/80 lg:w-72">
      <div>
        <p className="text-xs uppercase tracking-[0.5em] text-white/50">Space</p>
        <div className="mt-3 rounded-2xl border border-white/5 bg-gradient-to-br from-white/10 to-white/0 p-5">
          <Cloud className="h-10 w-10 text-brand" />
          <p className="mt-5 text-sm text-white/60">已使用</p>
          <p className="text-3xl font-semibold text-white">{usage.toFixed(1)} MB</p>
          <div className="mt-4 h-2 rounded-full bg-white/10">
            <div className="h-2 rounded-full bg-gradient-to-r from-brand to-accent" style={{ width: `${Math.min(usage / 2048, 1) * 100}%` }} />
          </div>
          <p className="mt-2 text-xs text-white/40">限制 2 GB / 文件</p>
        </div>
      </div>

      <nav className="flex flex-col gap-2">
        {navItems.map((item) => (
          <button
            key={item.value}
            onClick={() => onChange?.(item.value)}
            className={clsx(
              'flex items-center gap-3 rounded-2xl px-4 py-3 text-sm transition',
              active === item.value
                ? 'bg-white/10 text-white shadow-inner shadow-black/40'
                : 'text-white/60 hover:bg-white/5 hover:text-white',
            )}
          >
            <item.icon className="h-4 w-4" />
            {item.label}
          </button>
        ))}
      </nav>
    </aside>
  );
}
